import { render, staticRenderFns } from "./AttendanceGrades.vue?vue&type=template&id=1917ab7e"
import script from "./AttendanceGrades.vue?vue&type=script&lang=js"
export * from "./AttendanceGrades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports